<section>
  <header class="primary">
    <h2>Closed Case</h2>
  </header>
  <main>{{ data.message }}</main>
  <footer>
    <div class="d-flex justify-between">
      <eap-button variant="primary" [label]="data.cancelButtonText" (clicked)="onClose()" tabindex="-1"></eap-button>
      <eap-button variant="primary" style="float: right" [label]="data.confirmButtonText" (clicked)="onConfirmClick()"
        tabindex="1"></eap-button>
    </div>
  </footer>
</section>